import { render, staticRenderFns } from "./Complete.vue?vue&type=template&id=0b94bfe4"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b94bfe4')) {
      api.createRecord('0b94bfe4', component.options)
    } else {
      api.reload('0b94bfe4', component.options)
    }
    module.hot.accept("./Complete.vue?vue&type=template&id=0b94bfe4", function () {
      api.rerender('0b94bfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/Complete.vue"
export default component.exports